class InfiniteScroll {
  constructor() {
    this.init();
  }

  init() {
    this.waitForProducts();
  }

  waitForProducts() {
    const checkInterval = setInterval(() => {
      // UPDATED: Broader list of common selectors for Shopify themes
      const productGrid = document.querySelector('.collection .grid') ||
                          document.querySelector('#product-grid') ||
                          document.querySelector('[id*="ProductGrid"]') ||
                          document.querySelector('.ProductList') ||         // Common in Prestige theme
                          document.querySelector('.product-list') ||        // Common in Impact theme
                          document.querySelector('.grid--uniform') ||       // Common in Impulse theme
                          document.querySelector('.collection-matrix');     // Old standard

      if (productGrid && productGrid.children.length > 0) {
        console.log('✅ Products loaded! Grid found:', productGrid.className);
        clearInterval(checkInterval);
        this.productGrid = productGrid;
        this.setupInfiniteScroll();
      } else {
        console.log('⏳ Waiting for product grid...');
      }
    }, 500);

    setTimeout(() => {
      clearInterval(checkInterval);
      if (!this.productGrid) {
        console.error('❌ Timeout: Could not find product grid. Please inspect the page and update the selector.');
      }
    }, 10000);
  }

  setupInfiniteScroll() {
    // UPDATED: Look for various pagination containers
    this.pagination = document.querySelector('.pagination') ||
                      document.querySelector('.Pagination') ||
                      document.querySelector('.pager') ||
                      document.querySelector('.pagination-custom');

    if (!this.pagination) {
      console.log('❌ No pagination found');
      return;
    }

    // UPDATED: specifically look for the "Next" link (often an arrow in your theme)
    // We look for any link with "page=" in the URL that comes AFTER the current page
    const allPageLinks = Array.from(this.pagination.querySelectorAll('a[href*="page="]'));
    
    // Logic to find the "next" page specifically
    const params = new URLSearchParams(window.location.search);
    const currentPage = parseInt(params.get('page')) || 1;
    
    this.nextLink = allPageLinks.find(link => {
      const href = link.getAttribute('href');
      const match = href.match(/page=(\d+)/);
      return match && parseInt(match[1]) > currentPage;
    });

    if (!this.nextLink) {
      // Fallback: If no explicit numbered link, look for a "next" arrow or label
      this.nextLink = this.pagination.querySelector('[rel="next"]') || 
                      this.pagination.querySelector('a[aria-label="Next"]');
    }

    if (!this.nextLink) {
      console.log('ℹ️ No next page link found (or last page reached)');
      return;
    }

    console.log('🚀 Infinite scroll activated! Next page:', this.nextLink.href);
    this.pagination.style.display = 'none';
    this.loading = false;
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    if (this.loading) return;

    const scrollPosition = window.innerHeight + window.scrollY;
    const threshold = document.body.offsetHeight - 1000; // Increased threshold to load earlier

    if (scrollPosition >= threshold && this.nextLink) {
      this.loadMore();
    }
  }

  async loadMore() {
    this.loading = true;
    console.log('📦 Loading page:', this.nextLink.href);

    try {
      const response = await fetch(this.nextLink.href);
      const text = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');

      // Use the SAME selector logic to find the new grid
      const newGrid = doc.querySelector('.collection .grid') ||
                      doc.querySelector('#product-grid') ||
                      doc.querySelector('[id*="ProductGrid"]') ||
                      doc.querySelector('.ProductList') ||
                      doc.querySelector('.product-list') ||
                      doc.querySelector('.grid--uniform') ||
                      doc.querySelector('.collection-matrix');

      if (!newGrid || newGrid.children.length === 0) {
        console.error('❌ New page loaded but no products found in grid');
        this.loading = false;
        return;
      }

      const newProducts = Array.from(newGrid.children);
      console.log(`✅ Adding ${newProducts.length} products`);

      newProducts.forEach(product => {
        this.productGrid.appendChild(product.cloneNode(true));
      });

      // Find the next link in the NEW page to update our reference
      const newPagination = doc.querySelector('.pagination') || 
                            doc.querySelector('.Pagination') || 
                            doc.querySelector('.pager');
                            
      if (newPagination) {
        const params = new URLSearchParams(this.nextLink.search); 
        const currentPage = parseInt(params.get('page')); // The page we just loaded
        
        const allPageLinks = Array.from(newPagination.querySelectorAll('a[href*="page="]'));
        this.nextLink = allPageLinks.find(link => {
          const href = link.getAttribute('href');
          const match = href.match(/page=(\d+)/);
          return match && parseInt(match[1]) > currentPage;
        }) || newPagination.querySelector('[rel="next"]');
        
        if (!this.nextLink) {
            console.log('🏁 Reached the last page');
        }
      } else {
        this.nextLink = null;
      }

    } catch (error) {
      console.error('❌ Error loading more products:', error);
    }

    this.loading = false;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new InfiniteScroll();
});